import React from "react";

const ADConfirmation = () => {
	const { lang } = global;

	return (
		<div
			id="confirmation-page"
			className="container-fluid"
		>
			<div className="row">
				<div className="col-xs-12">
					<img
						src="/images/rk-logo-new.png"
						alt="RollKall"
						className="img-responsive"
					/>
				</div>
			</div>
			<div className="row confirmation-message text-center">
				<div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
					<p>
						{`${lang.t("Thank you for your submission_")}
						${lang.t("You are currently in our queue to verify your information_")}
						${lang.t("You will receive an email when your account has been verified and activated within the next 2-3 business days_")}
						`}
					</p>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12 text-center">
					<a href="/login">{lang.t("Back to Login")}</a>
				</div>
			</div>
		</div>
	);
};

export default ADConfirmation;
